import { useEffect } from 'react'

/**
 * useAutoRefreshOnCompletion
 *
 * Lightweight hook placeholder to trigger a fast refresh callback when
 * external completion signals are available. Currently, real-time refresh
 * is handled in DataSource via running jobs tracking; this hook ensures
 * type-safety and future extension without breaking imports.
 */
export function useAutoRefreshOnCompletion(onRefresh: () => void): void {
	// Placeholder: no-op effect retains stable reference to the callback
	useEffect(() => {
		// In future, wire up event listeners or subscriptions that call onRefresh()
		return () => {
			// Clean up any future subscriptions here
		}
	}, [onRefresh])
}

